module.exports = __webpack_public_path__ + "img/sup_wallet_6.6ba432e7.jpg";